<template>
  <v-app id="inspire">
    <v-toolbar color="white" fixed clipped-left app>
      <v-toolbar-title>
        <v-img class="hidden-sm-and-down" width="150" :src="require('@/assets/img/logo.jpg')"/>
        <v-img class="hidden-md-and-up" width="30" :src="require('@/assets/img/logo-symbol.jpg')"/>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn :to="{name: 'login'}" color="primary" >Zaloguj</v-btn>
      <v-btn :to="{name: 'register-self'}" color="accent" >Zarejestruj</v-btn>
    </v-toolbar>
    <v-content>
      <v-container fill-height>
        <v-layout>
          <v-flex>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-footer absolute inset app class="justify-center">
      <span>&copy; Inżynieria Biegania {{new Date().getFullYear()}}</span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  computed: {
    year: function () {
      return new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/UnauthenticatedLayout.vue